import menus from './menus';
import defaultSeoFields from './defaultSeoFields';

const defaultPageData = `
  ${defaultSeoFields}
  ${menus}
`;

export default defaultPageData;
